import { AppFooter, AppHeader, AuthStatus, ErrorBoundary } from './components';
import { useExternalAuthComplete } from './hooks/useExternalAuthComplete';

export const ExternalAuthComplete = () => {
  const authState = useExternalAuthComplete();

  return (
    <ErrorBoundary>
      <div className="flex min-h-screen flex-col">
        <AppHeader />
        <AuthStatus {...authState} />
        <AppFooter />
      </div>
    </ErrorBoundary>
  );
};
